import en from '@/assets/i18n/en.json'
import no from '@/assets/i18n/no.json'
import sv from '@/assets/i18n/sv.json'
import zh_CN from '@/assets/i18n/zh-CN.json'
import zh_HK from '@/assets/i18n/zh-HK.json'
import Vue from 'vue'
import vuei18n from 'vue-i18n'

Vue.use(vuei18n)
//const lcl = localStorage.getItem("lang") ?? "en-US";
export default new vuei18n({
    messages: {
        en: en,
        no: no,
        sv: sv,
        'en-GB': en,
        'en-US': en,
        'nb-NO': no,
        'sv-SE': sv,
        'zh-CN': zh_CN,
        'zh-HK': zh_HK,
    },
    silentTranslationWarn: true
})
